<template>
  <a :href="href" class="btn-custom btn-custom-{{type}}">
    <slot></slot>
  </a>
</template>
<script>
export default {
  props: {
    type: {
      default: 'default'
    },
    href: {
      type: String,
      default: 'javascript:;'
    }
  }
}
</script>
<style scoped lang='scss'>
$gray-deep:      #525a66;
$gray-lightest:  #e8ebf0;
$red:            #e6454a;
@mixin line-1px($background:$gray-lightest) {
  content: '';
  width: 200%;
  height: 200%;
  border: 1px solid $background;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  position: absolute;
  left: 0;
  top: 0;
  z-index:1;
}

@mixin radius($amount: 5px) {
  border-radius: $amount;
}

@mixin line-1px-radius($amount:6px, $border:$gray-lightest,$background:transparent) {
  @include line-1px($border);
  @include radius($amount);
  background:$background;
  z-index: -1;
}
a{
  text-decoration: none;
}
.btn-custom {
  -webkit-box-sizing:border-box;
  box-sizing:border-box;
  display: inline-block;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  position: relative;
  width: 100%;
  font-size: 17px;
  padding: 14px 15px;
  color: $gray-deep;

}

.btn-custom:focus,
.btn-custom.focus,
.btn-custom:active:focus,
.btn-custom:active.focus,
.btn-custom.active:focus,
.btn-custom.active.focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
  outline: none
}

.btn-custom-default {
  &:after {
    @include line-1px-radius(10px, $gray-deep);
  }
}

.btn-custom-default-active {
  color: $red;
  &:after {
    @include line-1px-radius(10px, $red);
  }
}

%primary{
  color: #fff;
  &:after {
    @include line-1px-radius(10px, #e6454a, #e6454a);
  }
}
.btn-custom-primary {
  @extend %primary;
}
.btn-custom-primary:active {
  &:after {
    @include line-1px-radius(10px, #c23a3f, #c23a3f);
  }
}
.btn-custom-disabled {
  color:rgba(255,255,255,.6);
  &:after {
    @include line-1px-radius(10px, #f08f92, #f08f92);
  }
}

.btn-custom-link{
  color:$red;
}
@media (min-width: 992px) {
  .twoalert .btn-custom {

    width:50%;
    display: table-cell;
  }
}
</style>



// WEBPACK FOOTER //
// BtnPop.vue?0b89d81b